import { selectedLanguage } from './variables';

const translations = {
    en: {
        // Common
        'required': 'Required',
        'optional': 'Optional',
        'continue': 'Continue',
        'back': 'Back',
        'close': 'Close',
        'submit': 'Submit',
        'save': 'Save',
        'cancel': 'Cancel',
        'processing': 'Processing...',
        'loading': 'Loading...',
        'copy': 'Copy',
        'apply': 'Apply',
        'yes': 'Yes',
        'no': 'No',
        'from': 'From',
        'to': 'to',
        'total': 'Total',
        'minutes': 'minutes',
        'minute': 'minute',

        // Navigation / Dashboard
        'instant_actions': 'Instant actions',
        'book_appointment': 'Book Appointment',
        'instant_quote': 'Instant Quote',
        'ask_question': 'Ask a Question',
        'call_us': 'Call Us',
        'text_us': 'Text Us',

        // Name / Contact fields
        'full_name': 'Full Name',
        'full_name_placeholder': 'Enter your full name',
        'first_name': 'First Name',
        'last_name': 'Last Name',
        'email': 'Email address',
        'email_placeholder': 'Enter your email address',
        'phone': 'Phone number',
        'phone_placeholder': 'Enter your phone number',
        'dob': 'Date of Birth',
        'month': 'Month',
        'day': 'Day',
        'year': 'Year',
        'dob_step_title': 'One last thing',
        'dob_step_subtitle': 'Please enter your date of birth to complete your request.',

        // Gender
        'gender': 'Gender',
        'select_gender': 'Select gender',
        'male': 'Male',
        'female': 'Female',
        'other': 'Other',
        'prefer_not_to_say': 'Prefer not to say',

        // Address
        'address': 'Address',
        'zip_code': 'ZIP Code',
        'zip_code_placeholder': 'Enter your ZIP code',

        // Insurance
        'insurance': 'What is your insurance? (if you have one)',

        // Location / Provider
        'select_location': 'Select a location',
        'select_provider': 'Select a provider',
        'no_preference': 'No preference',
        'any_provider': 'Any provider',
        'soonest_available': 'soonest available',
        'no_locations_found': 'No locations found',
        'no_providers_found': 'No Providers Found',
        'location': 'Location',

        // Services / Procedures
        'select_category': 'Select a category',
        'no_categories_found': 'No Categories Found',
        'no_procedures_found': 'No Procedures Found',
        'add_procedure': 'Add procedure',
        'services': 'Services',
        'consultation_required': 'Consultation required for an estimate',

        // Add-ons
        'select_addons': 'Select Add-Ons',
        'select_all_that_applies': 'Select all that applies',
        'only_one_addon': 'You can only select 1 addon',
        'no_addons': 'No Add-Ons',
        'apply_addons': 'Apply Add-Ons',

        // Scheduling
        'no_schedules_found': 'No Schedules found.',
        'all_booked': '{provider} all booked on this day',
        'choose_another_day': 'Choose another day to view open slots',
        'next_available': 'Next available slot is {date}',
        'time_unavailable': 'Time unavailable',
        'duration': 'Duration: {duration} {unit}',

        // Days of week (abbreviated)
        'day_mon': 'Mon',
        'day_tue': 'Tue',
        'day_wed': 'Wed',
        'day_thu': 'Thu',
        'day_fri': 'Fri',
        'day_sat': 'Sat',
        'day_sun': 'Sun',

        // Appointment status
        'confirmed': 'Confirmed',
        'pending': 'Pending',
        'complete': 'Complete',
        'cancelled': 'Cancelled',

        // Appointment cancel
        'why_cancelling': 'Why are you cancelling?',
        'cancel_reason_emergency': 'Emergency',
        'cancel_reason_conflict': 'Conflict',
        'cancel_reason_not_needed': 'Not needed',
        'cancel_reason_placeholder': 'Tell us your reason for cancelling...',
        'cancel_appointment': 'Cancel Appointment',
        'cancel_provide_reason': 'Please provide a reason for cancellation',
        'cancel_min_chars': 'Please provide at least 10 characters for the cancellation reason',
        'cancel_success': 'Appointment cancelled successfully',
        'cancel_failed': 'Failed to cancel appointment. Please try again.',
        'card_required_message': 'Please add a card on file before changing this appointment. It is held for the cancellation policy and is not charged now.',
        'card_required_add': 'Add your card',
        'card_required_retry': 'Once your card is saved, come back to this tab and press the button again.',

        // Appointment reschedule
        'why_rescheduling': 'Please tell us why',
        'reschedule_reason_conflict': 'Schedule conflict',
        'reschedule_reason_emergency': 'Emergency',
        'reschedule_reason_personal': 'Personal reasons',
        'reschedule_reason_placeholder': 'Tell us your reason for rescheduling...',
        'confirm_reschedule': 'Confirm Reschedule',
        'reschedule_provide_reason': 'Please provide a reason for rescheduling',
        'reschedule_min_chars': 'Please provide at least 10 characters for the reschedule reason',
        'reschedule_success': 'Appointment rescheduled successfully',
        'reschedule_failed': 'Failed to reschedule appointment. Please try again.',

        // Appointment summary
        'no_procedures_selected': 'No procedures selected',

        // How did you hear
        'how_did_you_hear': 'How did you hear about us?',

        // Another question
        'another_question': 'I have another question',

        // Language
        'select_language': 'Select language',
        'language_english': 'English',
        'language_spanish': 'Spanish',
        'preferred_language': 'Preferred Language',

        // Upload
        'upload': 'Upload',

        // Height
        'feet': 'Ft',
        'inches': 'In',

        // Consult summary
        'total_services': 'Total ({count} services)',

        // Custom field
        'custom_field': 'Custom field',
        'select_an_option': 'Select an option',

        // Addons summary
        'addons_count': '+{count} addons',

        // Consult summary
        'free': 'Free',
        'consult_fee_applied': 'Consult fee is applied to service costs',

        // Staff info panel
        'meet_with': 'Meet with',
        'no_staffs': 'No staffs',
        'no_services': 'No services',
        'duration_label': 'Duration',
        'appointment_type': 'Appointment Type',
        'description': 'Description',
        'provider': 'Provider',
        'providers': 'Providers',
        'phone_label': 'Phone',
        'office_hours': 'Office Hours',
        'get_directions': 'Get directions',
        'services_available': 'services available',

        // Phone entry
        'phone_entry_subtitle': 'Enter your phone number to book an appointment',
        'your_phone_number': 'Your phone number',

        // Provider selection
        'no_preference': 'No preference',
        'team_members': 'Team members',

        // Custom questions
        'questions_submitted': 'Questions submitted successfully!',
        'questions_failed': 'Failed to submit questions. Please try again.',

        // Upload photos
        'skip_step': 'Skip Step',
        'uploaded': 'Uploaded',
        'upload_failed_status': 'Failed',
        'image_size_error': 'Image size should not be larger than 10mb',
        'image_type_error': 'Only jpg/jpeg/gif and png files are allowed!',

        // Footer
        'powered_by': 'Powered by',

        // Appointment confirmed page
        'reschedule': 'Reschedule',
        'start_paperwork': 'Start Paperwork',
        'book_new_appointment': 'Book New Appointment',
        'appointment_cancelled_page_title': 'This appointment was cancelled',
        'appointment_gone_page_title': 'This appointment is no longer available',
        'appointment_gone_page_subtitle': 'Need to come in? You can book a new appointment below.',
        'join_video_call': 'Join video call',
        'appointment_booked': 'Your appointment has been booked',
        'confirm_appointment_btn': 'Confirm Appointment',
        'book_new_appointment': 'Book New Appointment',
        'pending_approval_title': 'Appointment pending — waiting for staff approval.',
        'pending_approval_desc': "This time is reserved, but your appointment is not confirmed yet. We'll notify you once our team approves it.",
        'inquiry_fallback_message': 'Our front desk will contact you shortly to schedule your appointment.',
        'cancelled_banner_title': 'Appointment cancelled',
        'cancelled_banner_desc': 'Your appointment has been successfully cancelled. You can book a new appointment anytime.',
        'appointment_cancelled_title': 'Your appointment has been cancelled',
        'confirm_cancel_dialog': 'Are you sure you want to cancel this appointment?',
        'address_copied': 'Address copied to clipboard',
        'confirm_appointment_success': 'Appointment confirmed!',
        'confirm_appointment_failed': 'Error confirming appointment. Please try again.',
        'error_event_id_not_found': 'Error: Event ID not found',
        'error_location_undefined': 'Error! Location is undefined.',
        'error_copy_failed': 'Error! Cannot copy to clipboard.',
        'error_room_url_unavailable': 'Event room URL is not available',
        'error_invalid_response': 'Invalid response from server',
        'error_event_cancelled': 'Event has been cancelled.',
        'error_load_appointment_summary': 'Unable to load appointment summary.',

        // Screen titles
        'top_asked_questions': 'Top asked questions',
        'request_consult_title': 'Request consult',
        'get_an_instant_estimate': 'Get an instant estimate',
        'consult_scheduling': 'Consult Scheduling',
        'hello_there': 'Hello there!',
        'when_done': 'When would you like this done?',
        'interest_just_curious': 'Just curious',
        'interest_as_soon_as_possible': 'As soon as possible',
        'interest_few_months': 'A few months',
        'enter_phone_number': 'Enter phone number',
        'appointment_booking_login': 'Appointment Booking Login',
        'enter_phone_to_book': 'Enter your phone number to book an appointment',
        'enter_4_digit_code': 'Enter 4 digit code sent to phone',
        'sent_to': 'Sent to',
        'resend': 'Resend',
        'enter_otp_code': 'Enter OTP Code',
        'register_as_new_patient': 'Register as new patient',
        'tell_us_about_yourself': 'Tell us about yourself',
        'client_portal_info': 'This information is needed to setup your client portal',
        'your_instant_quote': 'Your Instant Quote',
        'book_your_appointment': 'Book your appointment',
        'your_address': 'Your Address',
        'appointment_summary_title': 'Appointment summary',
        'payment_method': 'Payment method',
        'instant_quote_title': 'Instant quote',
        'we_will_reach_back': 'We will reach back to you',

        // Dynamic titles / screens
        'get_instant_estimate': 'Get your instant estimate',
        'select_services': 'Select services',
        'select_date_time': 'Select a Date & Time',
        'available_time': 'Available time',
        'select_time_with': 'Select Time with',

        // Provider / location errors
        'no_location_found': 'No location found',
        'provider_no_location': 'Provider does not offer this location',
        'provider_no_service': 'Provider does not offer this service',

        // Actions / buttons
        'book_now': 'Book now',
        'ask_a_question': 'Ask a question',
        'new_patient': 'New Patient',
        'returning_patient': 'Returning Patient',
        'qualification_form': 'Qualification Form',
        'more': 'More',
        'unsupported_question_type': 'Unsupported question type:',
        'enter_patient_information': 'Enter Patient Information',
        'saving': 'Saving...',
        'confirm': 'Confirm',
        'request_appointment': 'Request Appointment',
        'remove_procedure': 'Remove Procedure',
        'cannot_select_procedure': 'Cannot select this procedure if {name} is selected',

        // Formatting
        'per_month': '/mo',
        'virtual': 'Virtual',
        'virtual_meeting': 'Virtual Meeting',
        'virtual_appointment': 'Virtual appointment',
        'in_person': 'In-Person',
        'phone_call': 'Phone Call',
        'select_visit_type': 'How would you like to meet?',
        'virtual_visit_desc': 'Meet from the comfort of your home',
        'in_person_visit_desc': 'Visit the office in person',
        'phone_visit_desc': 'Meet over the phone',
        'phone_visit_desc_duration': 'Meet for a {duration}-minute phone call',
        'click_to_copy': 'Click to copy',
        'greeting_hi': 'Hi',

        // Placeholders
        'type_desired_service': 'Type Your Desired Service',
        'mobile_phone_placeholder': 'Mobile Phone',
        'full_name_short_placeholder': 'First Last',
        'whats_your_question': "What's your question?",
        'address_main_placeholder': '123 Main St',
        'apt_suite_placeholder': 'Apt 4B',
        'city_short': 'City',
        'state_short': 'State',
        'zip_short': 'ZIP',
        'select_dob': 'Select your date of birth.',
        'enter_first_name': 'Enter your first name',
        'enter_last_name': 'Enter your last name',

        // Field labels
        'your_full_name_label': 'Your full name',
        'your_first_last_name_label': 'Your first and last name',
        'your_email_address_label': 'Your email address',
        'email_address_label': 'Email address',
        'street_address_label': 'Street Address',
        'apt_suite_optional_label': 'Apt / Suite (optional)',

        // Server-returned error messages
        'server_error_unauthenticated': 'Session expired. Please try again.',
        'server_error_code_expired': 'The code has expired. Please request a new one.',
        'server_error_invalid_code': 'Invalid code. Please check and try again.',
        'server_error_invalid_data': 'The information provided is invalid. Please check and try again.',
        'server_error_too_many_attempts': 'Too many attempts. Please wait a moment and try again.',
        'server_error_generic': 'An error occurred. Please try again.',

        // Short / additional placeholders
        'first_last_name_placeholder': 'First and Last Name',
        'email_short': 'Email',
        'edit_btn': 'Edit',

        // Email screen
        'notify_future_specials': 'Notify me of future specials',

        // SMS consent aria-labels
        'sms_transactional_aria': 'Transactional and informational SMS consent',
        'terms_privacy_aria': 'Accept Terms and Conditions and Privacy Policy',
        'sms_promotional_aria': 'Promotional and marketing SMS consent',
        'sms_disclaimer': 'Message and data rates may apply. Message frequency varies. Reply STOP to unsubscribe, HELP for help.',
        // SMS consent label text (split around dynamic business name / links)
        'sms_transactional_before': 'I agree to receive transactional text messages and/or emails from ',
        'sms_transactional_after': ' (e.g. verification codes, account & care messages).',
        'sms_promotional_before': 'I agree to receive promotional text messages and/or emails from ',
        'sms_promotional_after': '. Message frequency varies. Message and data rates may apply. Reply STOP to unsubscribe.',
        'sms_passive_before': 'By continuing, you consent to receive text messages and/or emails from ',
        'sms_passive_after': '. Msg & data rates may apply. Message frequency varies. Reply STOP to opt out.',
        'terms_privacy_before': 'I accept the ',
        'terms_privacy_mid': ' and ',
        'terms_privacy_after': '.',
        'terms_and_conditions': 'Terms and Conditions',
        'privacy_policy': 'Privacy Policy',

        // Consult scheduling screen
        'ready_to_schedule': 'Ready to schedule a consultation?',
        'i_am_new_user': 'I am a new user',
        'i_am_existing_user': 'I am an existing user',

        // Instant quote
        'request_consultation': 'Request Consultation',
        'as_low_as': 'as low as',
        'total_lowercase': 'total',
        'cost_breakdown': 'Cost Breakdown',
        'no_estimate_info': 'No Estimate Information',
        'estimate_disclaimer': 'The result above is a rough estimate. Feel free to call/text for questions, or book a consult to get a personalized assessment and pricing.',

        // Surgical selection
        'surgical': 'Surgical',
        'non_surgical': 'Non-Surgical',

        // Address collection
        'address_subtitle': 'Please provide your address to complete your booking.',

        // Appointment summary
        'please_confirm_appointment': 'Please confirm your appointment',
        'minute_consult_required': 'Minute Consult Required for the Selected Services',
        'save_card_and_confirm': 'Save card and confirm',
        'sign_in': 'Sign in',
        'appointment_date': 'Appointment date',

        // Reschedule screens
        'reschedule_appointment': 'Reschedule appointment',
        'reschedule_your_appointment': 'Reschedule your appointment',
        'current_label': 'Current',
        'new_time_label': 'New time',

        // Provider scheduling
        'available_date': 'Available date',

        // Consult summary
        'still_interested_consult': 'Still interested, request a consultation',
        'consult_summary': 'Consult Summary',

        // Upload photos
        'upload_your_photos': 'Upload your photos',
        'upload_photos_desc': 'Upload your photos so our providers can assess your qualification',
        'upload_click_or_drag': 'Click or drag your photos to this area',
        'upload_multiple_files': 'you can upload more than 1 file',

        // Gender / body selection
        'select_your_gender': 'Select your gender',
        'select_problem_areas': 'Select one or more problem areas',

        // Book appointment
        'book_an_appointment': 'Book an Appointment',
        'click_continue_to_book': 'Click continue to book your appointment',

        // All questions screen
        'questions_title': 'Questions',

        // Verify information
        'verify_information_title': 'Verify Information',
        'verify_information_subtitle': 'Verify information',
        'verify_information_desc': 'Please verify information before continue',
        'verify_btn': 'Verify',

        // Patient selection
        'are_you_new_patient': 'Are you a new patient?',

        // Call us
        'select_location_to_call': 'Select Location to Call',

        // End screen
        'thanks': 'Thanks!',
        'message_received': "We got your message. We will be in touch soon!",
    },

    es: {
        // Common
        'required': 'Requerido',
        'optional': 'Opcional',
        'continue': 'Continuar',
        'back': 'Atrás',
        'close': 'Cerrar',
        'submit': 'Enviar',
        'save': 'Guardar',
        'cancel': 'Cancelar',
        'processing': 'Procesando...',
        'loading': 'Cargando...',
        'copy': 'Copiar',
        'apply': 'Aplicar',
        'yes': 'Sí',
        'no': 'No',
        'from': 'Desde',
        'to': 'a',
        'total': 'Total',
        'minutes': 'minutos',
        'minute': 'minuto',

        // Navigation / Dashboard
        'instant_actions': 'Acciones rápidas',
        'book_appointment': 'Reservar Cita',
        'instant_quote': 'Cotización Instantánea',
        'ask_question': 'Hacer una Pregunta',
        'call_us': 'Llámanos',
        'text_us': 'Escríbenos',

        // Name / Contact fields
        'full_name': 'Nombre Completo',
        'full_name_placeholder': 'Ingrese su nombre completo',
        'first_name': 'Nombre',
        'last_name': 'Apellido',
        'email': 'Correo electrónico',
        'email_placeholder': 'Ingrese su correo electrónico',
        'phone': 'Número de teléfono',
        'phone_placeholder': 'Ingrese su número de teléfono',
        'dob': 'Fecha de Nacimiento',
        'month': 'Mes',
        'day': 'Día',
        'year': 'Año',
        'dob_step_title': 'Una última cosa',
        'dob_step_subtitle': 'Por favor ingrese su fecha de nacimiento para completar su solicitud.',

        // Gender
        'gender': 'Género',
        'select_gender': 'Seleccionar género',
        'male': 'Masculino',
        'female': 'Femenino',
        'other': 'Otro',
        'prefer_not_to_say': 'Prefiero no decirlo',

        // Address
        'address': 'Dirección',
        'zip_code': 'Código Postal',
        'zip_code_placeholder': 'Ingrese su código postal',

        // Insurance
        'insurance': '¿Cuál es su seguro médico? (si tiene uno)',

        // Location / Provider
        'select_location': 'Seleccionar ubicación',
        'select_provider': 'Seleccionar proveedor',
        'no_preference': 'Sin preferencia',
        'any_provider': 'Cualquier proveedor',
        'soonest_available': 'próximo disponible',
        'no_locations_found': 'No se encontraron ubicaciones',
        'no_providers_found': 'No se encontraron proveedores',
        'location': 'Ubicación',

        // Services / Procedures
        'select_category': 'Seleccionar categoría',
        'no_categories_found': 'No se encontraron categorías',
        'no_procedures_found': 'No se encontraron procedimientos',
        'add_procedure': 'Agregar procedimiento',
        'services': 'Servicios',
        'consultation_required': 'Se requiere consulta para un presupuesto',

        // Add-ons
        'select_addons': 'Seleccionar Complementos',
        'select_all_that_applies': 'Seleccione todo lo que aplique',
        'only_one_addon': 'Solo puede seleccionar 1 complemento',
        'no_addons': 'Sin Complementos',
        'apply_addons': 'Aplicar Complementos',

        // Scheduling
        'no_schedules_found': 'No se encontraron horarios.',
        'all_booked': '{provider} completamente reservado este día',
        'choose_another_day': 'Elija otro día para ver los horarios disponibles',
        'next_available': 'Próximo horario disponible: {date}',
        'time_unavailable': 'Hora no disponible',
        'duration': 'Duración: {duration} {unit}',

        // Days of week (abbreviated)
        'day_mon': 'Lun',
        'day_tue': 'Mar',
        'day_wed': 'Mié',
        'day_thu': 'Jue',
        'day_fri': 'Vie',
        'day_sat': 'Sáb',
        'day_sun': 'Dom',

        // Appointment status
        'confirmed': 'Confirmado',
        'pending': 'Pendiente',
        'complete': 'Completado',
        'cancelled': 'Cancelado',

        // Appointment cancel
        'why_cancelling': '¿Por qué está cancelando?',
        'cancel_reason_emergency': 'Emergencia',
        'cancel_reason_conflict': 'Conflicto de horario',
        'cancel_reason_not_needed': 'Ya no es necesario',
        'cancel_reason_placeholder': 'Díganos el motivo de su cancelación...',
        'cancel_appointment': 'Cancelar Cita',
        'cancel_provide_reason': 'Por favor proporcione un motivo de cancelación',
        'cancel_min_chars': 'Por favor proporcione al menos 10 caracteres para el motivo de cancelación',
        'cancel_success': 'Cita cancelada exitosamente',
        'cancel_failed': 'Error al cancelar la cita. Por favor intente de nuevo.',
        'card_required_message': 'Agregue una tarjeta antes de cambiar esta cita. Se guarda para la política de cancelación y no se cobra ahora.',
        'card_required_add': 'Agregar tarjeta',
        'card_required_retry': 'Cuando su tarjeta esté guardada, vuelva a esta pestaña y presione el botón de nuevo.',

        // Appointment reschedule
        'why_rescheduling': 'Por favor díganos por qué',
        'reschedule_reason_conflict': 'Conflicto de horario',
        'reschedule_reason_emergency': 'Emergencia',
        'reschedule_reason_personal': 'Razones personales',
        'reschedule_reason_placeholder': 'Díganos el motivo del cambio de cita...',
        'confirm_reschedule': 'Confirmar Cambio de Cita',
        'reschedule_provide_reason': 'Por favor proporcione un motivo para el cambio de cita',
        'reschedule_min_chars': 'Por favor proporcione al menos 10 caracteres para el motivo del cambio de cita',
        'reschedule_success': 'Cita reprogramada exitosamente',
        'reschedule_failed': 'Error al reprogramar la cita. Por favor intente de nuevo.',

        // Appointment summary
        'no_procedures_selected': 'No se seleccionaron procedimientos',

        // How did you hear
        'how_did_you_hear': '¿Cómo se enteró de nosotros?',

        // Another question
        'another_question': 'Tengo otra pregunta',

        // Language
        'select_language': 'Seleccionar idioma',
        'language_english': 'English',
        'language_spanish': 'Español',
        'preferred_language': 'Idioma Preferido',

        // Upload
        'upload': 'Subir',

        // Height
        'feet': 'Pies',
        'inches': 'Pulgadas',

        // Consult summary
        'total_services': 'Total ({count} servicios)',

        // Custom field
        'custom_field': 'Campo personalizado',
        'select_an_option': 'Seleccionar una opción',

        // Addons summary
        'addons_count': '+{count} complementos',

        // Consult summary
        'free': 'Gratis',
        'consult_fee_applied': 'La tarifa de consulta se aplica a los costos del servicio',

        // Staff info panel
        'meet_with': 'Cita con',
        'no_staffs': 'Sin personal',
        'no_services': 'Sin servicios',
        'duration_label': 'Duración',
        'appointment_type': 'Tipo de Cita',
        'description': 'Descripción',
        'provider': 'Proveedor',
        'providers': 'Proveedores',
        'phone_label': 'Teléfono',
        'office_hours': 'Horario de atención',
        'get_directions': 'Cómo llegar',
        'services_available': 'servicios disponibles',

        // Phone entry
        'phone_entry_subtitle': 'Ingrese su número de teléfono para reservar una cita',
        'your_phone_number': 'Su número de teléfono',

        // Provider selection
        'no_preference': 'Sin preferencia',
        'team_members': 'Miembros del equipo',

        // Custom questions
        'questions_submitted': '¡Preguntas enviadas exitosamente!',
        'questions_failed': 'Error al enviar las preguntas. Por favor intente de nuevo.',

        // Upload photos
        'skip_step': 'Omitir Paso',
        'uploaded': 'Subido',
        'upload_failed_status': 'Error',
        'image_size_error': 'El tamaño de la imagen no debe ser mayor a 10mb',
        'image_type_error': '¡Solo se permiten archivos jpg/jpeg/gif y png!',

        // Footer
        'powered_by': 'Con tecnología de',

        // Appointment confirmed page
        'reschedule': 'Reprogramar',
        'start_paperwork': 'Comenzar formularios',
        'book_new_appointment': 'Reservar nueva cita',
        'appointment_cancelled_page_title': 'Esta cita fue cancelada',
        'appointment_gone_page_title': 'Esta cita ya no está disponible',
        'appointment_gone_page_subtitle': '¿Necesita venir? Puede reservar una nueva cita a continuación.',
        'join_video_call': 'Unirse a la videollamada',
        'appointment_booked': 'Su cita ha sido reservada',
        'confirm_appointment_btn': 'Confirmar Cita',
        'book_new_appointment': 'Reservar Nueva Cita',
        'pending_approval_title': 'Cita pendiente — esperando aprobación del personal.',
        'pending_approval_desc': 'Este horario está reservado, pero su cita aún no está confirmada. Le avisaremos cuando el equipo la apruebe.',
        'inquiry_fallback_message': 'Nuestra recepción se pondrá en contacto con usted en breve para programar su cita.',
        'cancelled_banner_title': 'Cita cancelada',
        'cancelled_banner_desc': 'Su cita ha sido cancelada exitosamente. Puede reservar una nueva cita en cualquier momento.',
        'appointment_cancelled_title': 'Su cita ha sido cancelada',
        'confirm_cancel_dialog': '¿Está seguro de que desea cancelar esta cita?',
        'address_copied': 'Dirección copiada al portapapeles',
        'confirm_appointment_success': '¡Cita confirmada!',
        'confirm_appointment_failed': 'Error al confirmar la cita. Por favor intente de nuevo.',
        'error_event_id_not_found': 'Error: ID de evento no encontrado',
        'error_location_undefined': '¡Error! La ubicación no está definida.',
        'error_copy_failed': '¡Error! No se puede copiar al portapapeles.',
        'error_room_url_unavailable': 'La URL de la sala del evento no está disponible',
        'error_invalid_response': 'Respuesta inválida del servidor',
        'error_event_cancelled': 'El evento ha sido cancelado.',
        'error_load_appointment_summary': 'No se pudo cargar el resumen de la cita.',

        // Screen titles
        'top_asked_questions': 'Preguntas frecuentes',
        'request_consult_title': 'Solicitar consulta',
        'get_an_instant_estimate': 'Obtenga un estimado instantáneo',
        'consult_scheduling': 'Programar consulta',
        'hello_there': '¡Hola!',
        'when_done': '¿Cuándo le gustaría hacerlo?',
        'interest_just_curious': 'Solo curiosidad',
        'interest_as_soon_as_possible': 'Lo antes posible',
        'interest_few_months': 'En unos meses',
        'enter_phone_number': 'Ingresar número de teléfono',
        'appointment_booking_login': 'Inicio de sesión para reserva de cita',
        'enter_phone_to_book': 'Ingresa tu número de teléfono para reservar una cita',
        'enter_4_digit_code': 'Ingresa el código de 4 dígitos enviado a tu teléfono',
        'sent_to': 'Enviado a',
        'resend': 'Reenviar',
        'enter_otp_code': 'Ingresar código OTP',
        'register_as_new_patient': 'Registrarse como nuevo paciente',
        'tell_us_about_yourself': 'Cuéntenos sobre usted',
        'client_portal_info': 'Esta información es necesaria para configurar su portal de cliente',
        'your_instant_quote': 'Su cotización instantánea',
        'book_your_appointment': 'Reserve su cita',
        'your_address': 'Su dirección',
        'appointment_summary_title': 'Resumen de la cita',
        'payment_method': 'Método de pago',
        'instant_quote_title': 'Cotización instantánea',
        'we_will_reach_back': 'Nos comunicaremos con usted',

        // Dynamic titles / screens
        'get_instant_estimate': 'Obtenga su estimado instantáneo',
        'select_services': 'Seleccionar servicios',
        'select_date_time': 'Seleccionar fecha y hora',
        'available_time': 'Hora disponible',
        'select_time_with': 'Seleccionar hora con',

        // Provider / location errors
        'no_location_found': 'No se encontró ubicación',
        'provider_no_location': 'El proveedor no ofrece esta ubicación',
        'provider_no_service': 'El proveedor no ofrece este servicio',

        // Actions / buttons
        'book_now': 'Reservar ahora',
        'ask_a_question': 'Hacer una pregunta',
        'new_patient': 'Paciente nuevo',
        'returning_patient': 'Paciente recurrente',
        'qualification_form': 'Formulario de calificación',
        'more': 'Más',
        'unsupported_question_type': 'Tipo de pregunta no compatible:',
        'enter_patient_information': 'Ingresar información del paciente',
        'saving': 'Guardando...',
        'confirm': 'Confirmar',
        'request_appointment': 'Solicitar cita',
        'remove_procedure': 'Quitar procedimiento',
        'cannot_select_procedure': 'No puede seleccionar este procedimiento si {name} está seleccionado',

        // Formatting
        'per_month': '/mes',
        'virtual': 'Virtual',
        'virtual_meeting': 'Reunión virtual',
        'virtual_appointment': 'Cita virtual',
        'in_person': 'En persona',
        'phone_call': 'Llamada telefónica',
        'select_visit_type': '¿Cómo prefiere reunirse?',
        'virtual_visit_desc': 'Reúnase desde la comodidad de su hogar',
        'in_person_visit_desc': 'Visite el consultorio en persona',
        'phone_visit_desc': 'Reúnase por teléfono',
        'phone_visit_desc_duration': 'Reúnase en una llamada telefónica de {duration} minutos',
        'click_to_copy': 'Clic para copiar',
        'greeting_hi': 'Hola',

        // Placeholders
        'type_desired_service': 'Escriba el servicio deseado',
        'mobile_phone_placeholder': 'Teléfono móvil',
        'full_name_short_placeholder': 'Nombre Apellido',
        'whats_your_question': '¿Cuál es su pregunta?',
        'address_main_placeholder': 'Calle Principal 123',
        'apt_suite_placeholder': 'Apto 4B',
        'city_short': 'Ciudad',
        'state_short': 'Estado',
        'zip_short': 'CP',
        'select_dob': 'Seleccione su fecha de nacimiento.',
        'enter_first_name': 'Ingrese su nombre',
        'enter_last_name': 'Ingrese su apellido',

        // Field labels
        'your_full_name_label': 'Su nombre completo',
        'your_first_last_name_label': 'Su nombre y apellido',
        'your_email_address_label': 'Su correo electrónico',
        'email_address_label': 'Correo electrónico',
        'street_address_label': 'Dirección',
        'apt_suite_optional_label': 'Apto / Suite (opcional)',

        // Server-returned error messages
        'server_error_unauthenticated': 'Sesión expirada. Por favor intente de nuevo.',
        'server_error_code_expired': 'El código ha expirado. Por favor solicite uno nuevo.',
        'server_error_invalid_code': 'Código inválido. Por favor verifique e intente de nuevo.',
        'server_error_invalid_data': 'La información proporcionada es inválida. Por favor verifique e intente de nuevo.',
        'server_error_too_many_attempts': 'Demasiados intentos. Por favor espere un momento e intente de nuevo.',
        'server_error_generic': 'Ocurrió un error. Por favor intente de nuevo.',

        // Short / additional placeholders
        'first_last_name_placeholder': 'Nombre y Apellido',
        'email_short': 'Correo',
        'edit_btn': 'Editar',

        // Email screen
        'notify_future_specials': 'Notificarme sobre ofertas futuras',

        // SMS consent aria-labels
        'sms_transactional_aria': 'Consentimiento de SMS transaccional e informativo',
        'terms_privacy_aria': 'Aceptar Términos y Condiciones y Política de Privacidad',
        'sms_promotional_aria': 'Consentimiento de SMS promocional y de marketing',
        'sms_disclaimer': 'Pueden aplicar tarifas de mensajes y datos. La frecuencia de mensajes varía. Responda STOP para cancelar la suscripción, HELP para ayuda.',
        // SMS consent label text (split around dynamic business name / links)
        'sms_transactional_before': 'Acepto recibir mensajes de texto y/o correos transaccionales de ',
        'sms_transactional_after': ' (p.ej. códigos de verificación, mensajes de cuenta y atención).',
        'sms_promotional_before': 'Acepto recibir mensajes de texto y/o correos promocionales de ',
        'sms_promotional_after': '. La frecuencia de mensajes varía. Pueden aplicar tarifas de mensajes y datos. Responda STOP para cancelar la suscripción.',
        'sms_passive_before': 'Al continuar, acepto recibir mensajes de texto y/o correos de ',
        'sms_passive_after': '. Pueden aplicar tarifas de mensajes y datos. La frecuencia varía. Responda STOP para cancelar.',
        'terms_privacy_before': 'Acepto los ',
        'terms_privacy_mid': ' y la ',
        'terms_privacy_after': '.',
        'terms_and_conditions': 'Términos y Condiciones',
        'privacy_policy': 'Política de Privacidad',

        // Consult scheduling screen
        'ready_to_schedule': '¿Listo para programar una consulta?',
        'i_am_new_user': 'Soy un nuevo usuario',
        'i_am_existing_user': 'Soy un usuario existente',

        // Instant quote
        'request_consultation': 'Solicitar Consulta',
        'as_low_as': 'desde',
        'total_lowercase': 'total',
        'cost_breakdown': 'Desglose de Costos',
        'no_estimate_info': 'Sin Información de Estimado',
        'estimate_disclaimer': 'El resultado anterior es un estimado aproximado. No dude en llamar/escribir para preguntas, o reserve una consulta para obtener una evaluación y precio personalizados.',

        // Surgical selection
        'surgical': 'Quirúrgico',
        'non_surgical': 'No Quirúrgico',

        // Address collection
        'address_subtitle': 'Por favor proporcione su dirección para completar su reserva.',

        // Appointment summary
        'please_confirm_appointment': 'Por favor confirme su cita',
        'minute_consult_required': 'Minutos de Consulta Requeridos para los Servicios Seleccionados',
        'save_card_and_confirm': 'Guardar tarjeta y confirmar',
        'sign_in': 'Iniciar sesión',
        'appointment_date': 'Fecha de la cita',

        // Reschedule screens
        'reschedule_appointment': 'Reprogramar cita',
        'reschedule_your_appointment': 'Reprograme su cita',
        'current_label': 'Actual',
        'new_time_label': 'Nueva hora',

        // Provider scheduling
        'available_date': 'Fecha disponible',

        // Consult summary
        'still_interested_consult': 'Todavía interesado, solicitar una consulta',
        'consult_summary': 'Resumen de Consulta',

        // Upload photos
        'upload_your_photos': 'Subir tus fotos',
        'upload_photos_desc': 'Sube tus fotos para que nuestros proveedores puedan evaluar tu calificación',
        'upload_click_or_drag': 'Haz clic o arrastra tus fotos a esta área',
        'upload_multiple_files': 'puedes subir más de 1 archivo',

        // Gender / body selection
        'select_your_gender': 'Selecciona tu género',
        'select_problem_areas': 'Selecciona una o más áreas problemáticas',

        // Book appointment
        'book_an_appointment': 'Reservar una Cita',
        'click_continue_to_book': 'Haz clic en continuar para reservar tu cita',

        // All questions screen
        'questions_title': 'Preguntas',

        // Verify information
        'verify_information_title': 'Verificar Información',
        'verify_information_subtitle': 'Verificar información',
        'verify_information_desc': 'Por favor verifica la información antes de continuar',
        'verify_btn': 'Verificar',

        // Patient selection
        'are_you_new_patient': '¿Eres un paciente nuevo?',

        // Call us
        'select_location_to_call': 'Seleccionar Ubicación para Llamar',

        // End screen
        'thanks': '¡Gracias!',
        'message_received': 'Recibimos tu mensaje. ¡Nos pondremos en contacto pronto!',
    },
};

// Map of known server-returned English error messages to i18n keys
const SERVER_ERROR_MAP = {
    'unauthenticated.': 'server_error_unauthenticated',
    'unauthenticated': 'server_error_unauthenticated',
    'session expired. please try again.': 'server_error_unauthenticated',
    'session expired': 'server_error_unauthenticated',
    'the code has expired.': 'server_error_code_expired',
    'invalid code.': 'server_error_invalid_code',
    'invalid otp': 'server_error_invalid_code',
    'the given data was invalid.': 'server_error_invalid_data',
    'too many attempts.': 'server_error_too_many_attempts',
    'too many requests.': 'server_error_too_many_attempts',
    'server error': 'server_error_generic',
    'internal server error': 'server_error_generic',
};

export function translateServerError(message) {
    if (!message) return message;
    const key = SERVER_ERROR_MAP[message.toLowerCase().trim()];
    return key ? t(key) : message;
}

export function t(key) {
    const lang = selectedLanguage || 'en';
    const dict = translations[lang] || translations['en'];
    return dict[key] ?? translations['en'][key] ?? key;
}

export function tDefault(key) {
    return translations['en'][key] ?? key;
}
